module.exports = __webpack_public_path__ + "static/media/16x16no3.ef31246d.jpg";